var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFatigueAssessment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0H24V24H0z",
    transform: "translate(-146 -1494) translate(146 1494)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H2.05V2.05H0z",
    transform: "translate(-146 -1494) translate(-238.371 1473.926) translate(390.423 26.472) translate(0 3.54) translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H7.64V2.05H0z",
    transform: "translate(-146 -1494) translate(-238.371 1473.926) translate(390.423 26.472) translate(0 3.54) translate(3.913 0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H2.05V2.05H0z",
    transform: "translate(-146 -1494) translate(-238.371 1473.926) translate(390.423 26.472) translate(0 7.081) translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H7.64V2.05H0z",
    transform: "translate(-146 -1494) translate(-238.371 1473.926) translate(390.423 26.472) translate(0 7.081) translate(3.913 0)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H2.05V2.05H0z",
    transform: "translate(-146 -1494) translate(-238.371 1473.926) translate(390.423 26.472) translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H7.64V2.05H0z",
    transform: "translate(-146 -1494) translate(-238.371 1473.926) translate(390.423 26.472) translate(0 0) translate(3.913)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H2.05V2.05H0z",
    transform: "translate(-146 -1494) translate(-238.371 1473.926) translate(390.423 26.472) translate(0 10.622) translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0H7.64V2.05H0z",
    transform: "translate(-146 -1494) translate(-238.371 1473.926) translate(390.423 26.472) translate(0 10.622) translate(3.913 0)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M15.742 20.147H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14.742a1 1 0 0 1 1 1v18.147a1 1 0 0 1-1 1zM.993 2.27v16.743h14.614V2.27z",
    transform: "translate(-146 -1494) translate(-238.371 1473.926) translate(388 22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFatigueAssessment);
export default __webpack_public_path__ + "static/media/fatigue-assessment.84429d52e18be702793cfe1ab1e2cd61.svg";
export { ForwardRef as ReactComponent };